class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      // Ensure overlay click handler is properly bound to this instance
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      } else {
        console.warn('Cart drawer overlay element not found');
      }
      this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
      // Support both desktop and mobile cart icons
      const cartLinks = document.querySelectorAll('.js-cart-icon-bubble');
      cartLinks.forEach(cartLink => {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      });
    }
  
    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {this.classList.add('animate', 'active')});
  
      // Ensure overlay click event is attached regardless of empty state
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        // Remove any existing listener first to prevent duplicates
        overlay.removeEventListener('click', this.close.bind(this));
        // Add the event listener
        overlay.addEventListener('click', this.close.bind(this));
      }
  
      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }
  
    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
  
      if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
  
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
  
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  
    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        // Only update element if it exists
        if (sectionElement && parsedState.sections && parsedState.sections[section.id]) {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }));
  
      setTimeout(() => {
        // Re-attach overlay click handler, whether cart has items or is now empty
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          // Use a named function for the event handler so we can reliably remove it
          if (!this._boundCloseFunction) {
            this._boundCloseFunction = this.close.bind(this);
          }
          overlay.removeEventListener('click', this._boundCloseFunction);
          overlay.addEventListener('click', this._boundCloseFunction);
        }
        this.open();
      });
    }
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  
    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-drawer', CartDrawer);
  
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
  }
  
  customElements.define('cart-drawer-items', CartDrawerItems);
  
  // Main cart drawer functionality
  document.addEventListener("DOMContentLoaded", function () {
      let timerInterval;
      const TIMER_STORAGE_KEY = "promoTimerData";
      const TIMER_DURATION = 480; // 08:00 en secondes
  
      const startCountdown = () => {
          const countdownElement = document.getElementById("countdown-timer");
          if (!countdownElement) return;
  
          const existingData = JSON.parse(localStorage.getItem(TIMER_STORAGE_KEY));
          const startTime = existingData?.startTime || Date.now();
  
          const updateTimer = () => {
              const elapsedTime = Math.floor((Date.now() - startTime) / 1000);
              let timeLeft = TIMER_DURATION - (elapsedTime % TIMER_DURATION);
  
              if (timeLeft <= 0) {
                  clearInterval(timerInterval);
                  countdownElement.textContent = "00:00";
  
                  // Redémarrer le timer
                  localStorage.setItem(TIMER_STORAGE_KEY, JSON.stringify({ startTime: Date.now() }));
                  setTimeout(startCountdown, 1000); // Redémarre après 1 seconde
                  return;
              }
  
              const minutes = Math.floor(timeLeft / 60);
              const seconds = timeLeft % 60;
              countdownElement.textContent = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
          };
  
          localStorage.setItem(TIMER_STORAGE_KEY, JSON.stringify({ startTime }));
          clearInterval(timerInterval);
          timerInterval = setInterval(updateTimer, 1000);
          updateTimer();
      };
  
      const interceptCartActions = () => {
          document.addEventListener("click", (event) => {
              const isCartIcon = event.target.closest("#cart-icon-bubble") || event.target.matches("#cart-icon-bubble");
              const isAddToCartButton = event.target.matches("[data-add-to-cart]") || event.target.closest("[data-add-to-cart]");
  
              if (isAddToCartButton || isCartIcon) {
                  setTimeout(startCountdown, 100);
              }
          });
      };
  
      const interceptAjaxRequests = () => {
          const originalFetch = window.fetch;
          window.fetch = async function (...args) {
              const response = await originalFetch(...args);
              if (
                  args[0].includes("/cart/add") ||
                  args[0].includes("/cart/change") ||
                  args[0].includes("/cart/update")
              ) {
                  setTimeout(startCountdown, 100);
              }
              return response;
          };
      };
  
      const initializeTimerOnPageLoad = () => {
          if (localStorage.getItem(TIMER_STORAGE_KEY)) {
              startCountdown();
          }
      };
  
      initializeTimerOnPageLoad();
      interceptCartActions();
      interceptAjaxRequests();
  
      // Remove the duplicate event listener - we use the dedicated handler below instead
      /* Handler was moved to handleBundleRemoveClick function */
  
      let lastCartUpdate = { key: null, quantity: null, time: 0 };
  
      // Global flag to prevent multiple simultaneous updates
      let isUpdatingCart = false;
  
      // Helper function to get line index from item key (for Shopify API)
      function getLineFromKey(itemKey) {
          // Find all cart items
          const cartItems = document.querySelectorAll('tr.cart-item');
          
          // Loop through items to find the one with matching key
          for (let i = 0; i < cartItems.length; i++) {
              const buttons = cartItems[i].querySelectorAll('.quantity__button[data-item-key]');
              const inputs = cartItems[i].querySelectorAll('.quantity__input');
              
              // Check if any button in this cart item has matching key
              for (const button of buttons) {
                  if (button.dataset.itemKey === itemKey) {
                      // Return 1-based index (Shopify cart API uses 1-based indexing)
                      return i + 1;
                  }
              }
              
              // Also check inputs in case they have the key
              for (const input of inputs) {
                  if (input.dataset.itemKey === itemKey) {
                      return i + 1;
                  }
              }
          }
          
          // Fallback: return the key itself if it's numeric (might be a line index already)
          if (!isNaN(itemKey) && String(parseInt(itemKey)) === String(itemKey)) {
              return parseInt(itemKey);
          }
          
          return null;
      }
  
      // Remove previous event listeners to ensure we don't duplicate
      document.removeEventListener('click', handleQuantityButtonClick);
      document.removeEventListener('change', handleQuantityInputChange);
      document.removeEventListener('submit', handleCartFormSubmit);
      document.removeEventListener('click', handleBundleRemoveClick);
  
      // Handler for quantity button clicks
      function handleQuantityButtonClick(event) {
          if (!event.target.closest('.quantity__button')) return;
          
          event.preventDefault();
          
          if (isUpdatingCart) {
              console.log('');
              return;
          }
          
          const button = event.target.closest('.quantity__button');
          const itemKey = button.dataset.itemKey;
          const newQuantity = parseInt(button.dataset.quantity);
          
          if (!itemKey) return;
          
          // Get the correct line number instead of using the key directly
          const cartLine = getLineFromKey(itemKey);
          if (!cartLine) {
              console.error('Could not determine cart line from item key:', itemKey);
              return;
          }
          
          isUpdatingCart = true;
          
          // Use cart-drawer-items component if available, otherwise fallback
          const cartItemsComponent = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
          
          // If we have the component, use its updateQuantity method
          if (cartItemsComponent && typeof cartItemsComponent.updateQuantity === 'function') {
              // Always use the cartLine (index) instead of the item key
              cartItemsComponent.updateQuantity(cartLine, newQuantity);
              
              // Set a timeout to reset the flag even if something goes wrong
              setTimeout(() => { isUpdatingCart = false; }, 3000);
              return;
          }
          
          updateCartItem(cartLine, newQuantity, button)
              .finally(() => {
                  isUpdatingCart = false;
              });
      }
      
      // Handler for quantity input changes
      function handleQuantityInputChange(event) {
          if (!event.target.classList.contains('quantity__input')) return;
          
          event.preventDefault();
          
          if (isUpdatingCart) {
              console.log('');
              return;
          }
          
          const input = event.target;
          const itemKey = input.dataset.itemKey || input.dataset.index;
          const newQuantity = parseInt(input.value);
          
          if (!itemKey || isNaN(newQuantity)) return;
          
          // Get the correct line number instead of using the key directly
          const cartLine = getLineFromKey(itemKey);
          if (!cartLine) {
              console.error('Could not determine cart line from item key:', itemKey);
              return;
          }
          
          isUpdatingCart = true;
          
          // Use cart-drawer-items component if available, otherwise fallback
          const cartItemsComponent = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
          
          // If we have the component, use its updateQuantity method
          if (cartItemsComponent && typeof cartItemsComponent.updateQuantity === 'function') {
              // Always use the cartLine (index) instead of the item key
              cartItemsComponent.updateQuantity(cartLine, newQuantity);
              
              // Set a timeout to reset the flag even if something goes wrong
              setTimeout(() => { isUpdatingCart = false; }, 3000);
              return;
          }
          
          updateCartItem(cartLine, newQuantity, input)
              .finally(() => {
                  isUpdatingCart = false;
              });
      }
      
      // Handler for cart form submissions
      function handleCartFormSubmit(event) {
          if (event.target.action && event.target.action.includes('/cart/update')) {
              // Prevent default form submission
              event.preventDefault();
          }
      }
  
      // Handler for bundle remove buttons
      function handleBundleRemoveClick(event) {
          // Target could be the button, SVG, or a path inside the SVG
          // We need to check all possibilities to ensure the click is captured properly
          const button = event.target.closest('button[data-bundle-id]');
          
          if (!button) return;
          
          event.preventDefault();
          
          if (isUpdatingCart) {
              console.log('');
              return;
          }
          
          const bundleId = button.dataset.bundleId;
          if (!bundleId) return;
          
          console.log('');
          isUpdatingCart = true;
          
          // Find all cart items with this bundle ID
          fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                  // Get all bundle items
                  const updates = {};
                  let foundBundle = false;
                  
                  // Mark all items in the bundle for removal
                  cart.items.forEach(item => {
                      // Handle properties safely
                      const properties = item.properties || {};
                      
                      // Both property access methods to be thorough
                      let bundleValue = null;
                      if (typeof properties === 'object') {
                          bundleValue = properties._bundle_id || properties['_bundle_id'];
                      }
                      
                      // Convert both values to strings for comparison
                      if (bundleValue !== null && String(bundleValue) === String(bundleId)) {
                          foundBundle = true;
                          updates[item.key] = 0; // Set quantity to 0 to remove
                      }
                  });
                  
                  if (!foundBundle) {
                      console.warn('No items found for bundle ID:', bundleId, 'Cart items:', cart.items);
                      isUpdatingCart = false;
                      return;
                  }
                  
                  // Update the cart to remove all bundle items at once - use the correct endpoint
                  return updateCartWithFallback('/cart/update.js', 'POST', { updates });
              })
              .then(response => {
                  if (!response) return null;
                  return response;
              })
              .then(updatedCart => {
                  if (!updatedCart) return;
                  
                  // Update the cart drawer
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                      // Get the sections to render
                      let sections = '';
                      if (cartDrawer.getSectionsToRender) {
                          sections = cartDrawer.getSectionsToRender().map(section => section.id).join(',');
                      } else {
                          sections = 'cart-drawer,cart-icon-bubble';
                      }
                      
                      // Fetch the updated cart sections
                      return fetch(`?sections=${sections}&sections_url=${window.location.pathname}`)
                          .then(response => response.json())
                          .then(sectionsData => {
                              // Show proper empty cart state if cart is now empty
                              if (updatedCart.item_count === 0) {
                                  if (!cartDrawer.classList.contains('is-empty')) {
                                      cartDrawer.classList.add('is-empty');
                                  }
                              }
                              
                              // Update the cart drawer content
                              cartDrawer.renderContents({ sections: sectionsData });
                              
                              // Wait for the DOM to update, then rebind the overlay click
                              setTimeout(function() {
                                  const overlay = document.querySelector('#CartDrawer-Overlay');
                                  if (overlay && cartDrawer) {
                                      // Remove any existing listeners (though they would be lost during innerHTML replacement)
                                      overlay.replaceWith(overlay.cloneNode(true));
                                      
                                      // Get the fresh overlay after replacement
                                      const newOverlay = document.querySelector('#CartDrawer-Overlay');
                                      if (newOverlay) {
                                          // Exactly match the binding method from the CartDrawer constructor
                                          newOverlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
                                          
                                          // Also add a direct click handler as a fallback to ensure it works
                                          newOverlay.addEventListener('click', function() {
                                              cartDrawer.classList.remove('active');
                                              document.body.classList.remove('overflow-hidden');
                                          });
                                      }
                                  }
                              }, 100);
                          })
                          .catch(error => {
                              console.error('Error fetching sections:', error);
                          });
                  }
              })
              .catch(error => {
                  console.error('Error removing bundle:', error);
              })
              .finally(() => {
                  isUpdatingCart = false;
              });
      }
  
      // Create a robust cart update helper that handles store discounts
      function updateCartWithFallback(url, method, data) {
          return fetch(url, {
              method: method,
              headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(data)
          })
          .then(response => {
              if (!response.ok) {
                  // For store discounts, the .js endpoint might fail with 422
                  if (response.status === 422 && url.endsWith('.js')) {
                      // Try the non-JS endpoint as fallback
                      console.log('');
                      return fetch(url.replace('.js', ''), {
                          method: method,
                          headers: {
                              'Content-Type': 'application/json',
                              'Accept': 'application/json',
                              'X-Requested-With': 'XMLHttpRequest'
                          },
                          body: JSON.stringify(data)
                      }).then(fallbackResponse => {
                          if (!fallbackResponse.ok) {
                              throw new Error(`Cart update failed: ${fallbackResponse.status}`);
                          }
                          return fallbackResponse.json();
                      });
                  }
                  throw new Error(`Cart update failed: ${response.status}`);
              }
              return response.json();
          });
      }
  
      function updateCartItem(lineOrId, newQuantity, element) {
          // Show loading state
          const cartItemRow = element ? element.closest('tr.cart-item') : null;
          if (cartItemRow) {
              const loadingOverlay = cartItemRow.querySelector('.loading-overlay');
              if (loadingOverlay) loadingOverlay.classList.remove('hidden');
          }
          
          // Determine if we're using line or id
          const isLineIndex = Number.isInteger(lineOrId) || (typeof lineOrId === 'string' && !lineOrId.includes(':') && /^\d+$/.test(lineOrId));
          
          // Prepare data for cart update
          const data = isLineIndex
              ? { line: lineOrId, quantity: newQuantity }
              : { id: lineOrId, quantity: newQuantity };
          
          // Use our robust update function with fallback
          return updateCartWithFallback('/cart/change.js', 'POST', data)
              .then(cart => {
                  // After updating the cart, we need to fetch the sections to update the drawer
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                      // Get the sections to render
                      let sections = '';
                      if (cartDrawer.getSectionsToRender) {
                          sections = cartDrawer.getSectionsToRender().map(section => section.id).join(',');
                      } else {
                          sections = 'cart-drawer,cart-icon-bubble';
                      }
                      
                      // Fetch the updated cart sections
                      fetch(`?sections=${sections}&sections_url=${window.location.pathname}`)
                          .then(response => response.json())
                          .then(sectionsData => {
                              cartDrawer.renderContents({ sections: sectionsData });
                          })
                          .catch(error => {
                              console.error('Error fetching sections:', error);
                              // Fallback - reload the page if fetching sections fails
                              window.location.reload();
                          });
                  } else {
                      // Fallback - reload the page if cartDrawer isn't available
                      window.location.reload();
                  }
              })
              .catch(error => {
                  console.error('Error updating cart:', error);
                  if (cartItemRow) {
                      const loadingOverlay = cartItemRow.querySelector('.loading-overlay');
                      if (loadingOverlay) loadingOverlay.classList.add('hidden');
                  }
              });
      }
  
      // Attach our event handlers
      document.addEventListener('click', handleQuantityButtonClick);
      document.addEventListener('change', handleQuantityInputChange);
      document.addEventListener('submit', handleCartFormSubmit);
      document.addEventListener('click', handleBundleRemoveClick);
  
  });
  